import getDeviceId from './deviceId';

const buildAuthHeaders = (userInfo) => {
  const headers = {
    'Content-type': 'application/json',
    'X-Device-Id': getDeviceId(),
    // Minutes behind UTC (Date.getTimezoneOffset). The backend keys streak
    // "days" off this so day boundaries follow the voter's clock — without
    // it a New York streak day rolled over at 8pm local.
    'X-TZ-Offset': String(new Date().getTimezoneOffset()),
  };
  if (userInfo?.access) headers.Authorization = `Bearer ${userInfo.access}`;
  return { headers };
};

export default buildAuthHeaders;
